import React, { Component, Fragment, useState } from "react";


import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";

import kycup from '../../assets/images/kyc-upload.svg';
import camera from '../../assets/images/camera.svg';


import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";
import { uploadKyc } from "../../Features/KYC/kycSlice";
import { useCustomizeContext } from "../../context";
import { Notify } from "notiflix";
import { useTranslation, I18nextProvider } from "react-i18next";

const Kyc = (props) => {
    const { t, i18n } = useTranslation();
    const {
        loader: {
            loading, setLoading,
        },
        languageContext: {
            language, setLanguage,
            changeLanguageRes, setChangeLanguageRes,
        },
        sideMenu: {
            classIsActive, setClassIsActive
        },
    } = useCustomizeContext();

    const [getKycInfo, setKycInfo] = useState("");

    const [kycFront, setKycFront] = useState("")
    const [kycBack, setKycBck] = useState("")
    const [kycSelfie, setKycSelfie] = useState("")

    const [kycFrontPreview, setKycFrontPreview] = useState("")
    const [kycBackPreview, setKycBackPreview] = useState("")
    const [kycSelfiePreview, setKycSelfiePreview] = useState("")

    const [updateRes, setUpdateRes] = useState("");


    let dispatch = useDispatch();

    useEffect(() => {
        getUserInfo();
    }, [updateRes, changeLanguageRes]);

    const getUserInfo = async () => {
        setLoading(true);
        let res = await dispatch(getUserDetails());
        setTimeout(() => {
            if (res?.status) {
                setKycInfo(res?.data?.details);
                setKycFront(res?.data?.details?.kyc_photo_proof1);
                setKycBck(res?.data?.details?.kyc_photo_proof2);
                setKycSelfie(res?.data?.details?.kyc_photo_self);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 1000);
    }


    useEffect(() => {
        document.body.classList.remove("SideMenuOpen");
        setClassIsActive(false);
    }, []);

    const SUPPORTED_FORMATS = [
        "image/jpg",
        "image/jpeg",
        "image/png"
    ];
    const kycFormSchema = yup.object().shape({

        kycfrontimage: yup.mixed()
            .test("required", "You need to provide a file", (file) => {
                if (file) return true;
                return false;
            })
            .test(
                "fileFormat",
                "Supported only jpg,jpeg,png formats only !!!",
                value => value && SUPPORTED_FORMATS.includes(value.type)
            ),
        kycbackimage: yup.mixed()
            .test("required", "You need to provide a file", (file) => {
                if (file) return true;
                return false;
            })
            .test(
                "fileFormat",
                "Supported only jpg,jpeg,png formats only !!!",
                value => value && SUPPORTED_FORMATS.includes(value.type)
            ),
        kycselfieimage: yup.mixed()
            .test("required", "You need to provide a file", (file) => {
                if (file) return true;
                return false;
            })
            .test(
                "fileFormat",
                "Supported only jpg,jpeg,png formats only !!!",
                value => value && SUPPORTED_FORMATS.includes(value.type)
            ),
    });

    const { register, handleSubmit, watch, reset, formState: { errors } } = useForm({
        mode: "onBlur"
    });

    const format = ["image/jpg", "image/png", "image/jpeg"];

    const handleChange = (event, type) => {
        const file = event.target.files[0];
        if (!format.includes(file.type)) {
            Notify.failure(`${t('JPG,PNG,JPEG format only allowed')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 });
        }
        else {
            if (type === "front") {
                setKycFront(event?.target?.files[0]);
                let reader = new FileReader();
                reader.onload = function () {
                    setKycFrontPreview(reader?.result);
                };
                reader.readAsDataURL(event.target.files[0]);
            }
            else if (type === "back") {
                setKycBck(event.target.files[0]);
                let reader = new FileReader();
                reader.onload = function () {
                    setKycBackPreview(reader.result);
                };
                reader.readAsDataURL(event.target.files[0]);
            }
            else {
                setKycSelfie(event.target.files[0]);
                let reader = new FileReader();
                reader.onload = function () {
                    setKycSelfiePreview(reader.result);
                };
                reader.readAsDataURL(event.target.files[0]);
            }
        }
    };

    const onsubmit = (data) => {

    }

    const updateKyc = async (e) => {
        if (kycFront !== "") {
            if (kycBack !== "") {
                if (kycSelfie !== "") {
                    e.preventDefault();
                    let data = new FormData();
                    data.append("kycfrontimage", kycFront);
                    data.append("kycbackimage", kycBack);
                    data.append("kycselfieimage", kycSelfie);
                    setLoading(true);
                    let res = await dispatch(uploadKyc(data, "formData"));
                    setTimeout(() => {
                        if (res?.status) {
                            setLoading(false);
                            setKycFront("");
                            setKycBck("");
                            setKycSelfie("");
                            setUpdateRes(res);
                        }
                        else {
                            setLoading(false);
                        }
                    }, 1000);
                }
                else {
                    Notify.failure(`${t('Selfie image is required')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 })
                }
            }
            else {
                Notify.failure(`${t('ID proof Back is required')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 })
            }
        }
        else {
            Notify.failure(`${t('ID proof Front is required')}`, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 })
        }
    }
    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">

                            <div className="kycpage-maincnt">

                                <div class="kycpage-main">
                                    <div class="d-flex align-items-center">
                                        <h5 class="page-head d-inline-block mb-0">KYC</h5>
                                        <div class="kyc-verfied">
                                            <div>
                                                {
                                                    getKycInfo?.kyc_photo_proof1_status === 1 && getKycInfo?.kyc_photo_proof2_status === 1 && getKycInfo?.kyc_photo_self_status === 1 ?
                                                        <>
                                                            <p>{t("Verified")}</p>
                                                        </>
                                                        :
                                                        getKycInfo?.kyc_photo_proof1_status === 2 || getKycInfo?.kyc_photo_proof2_status === 2 || getKycInfo?.kyc_photo_self_status === 2 ?
                                                            <>
                                                                <p class="text-danger">{t("Rejected")}</p>
                                                            </>
                                                            :
                                                            getKycInfo?.kyc_photo_proof1_status === 0 || getKycInfo?.kyc_photo_proof2_status === 0 || getKycInfo?.kyc_photo_self_status === 0 ?
                                                                <p class="text-danger">{t("Pending")}</p>
                                                                :
                                                                <p class="text-danger">{t("Not Uploaded")}</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="kyc-inrcnt">
                                        <form onSubmit={handleSubmit(onsubmit)}>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label for="">{t("Front Side ID Proof")}</label>
                                                        <div class="kyc-upload">
                                                            <input type="file" disabled={getKycInfo?.kyc_photo_proof1_status === 1 || getKycInfo?.kyc_photo_proof1_status === 0 ? true : false} id="front-id"
                                                                onChange={(e) => handleChange(e, "front")}
                                                                name="kycfrontimage"
                                                            />
                                                            <label for="front-id" style={{ cursor: getKycInfo?.kyc_photo_proof1_status === 1 || getKycInfo?.kyc_photo_proof1_status === 0 ? "not-allowed" : "pointer" }}>
                                                                <div class="choosefile-grid">
                                                                    <div>
                                                                        {
                                                                            getKycInfo?.kyc_photo_proof1_status === 1 ?
                                                                                <p>{t("Approved")}</p>
                                                                                :
                                                                                getKycInfo?.kyc_photo_proof1_status === 2 ?
                                                                                    <p class="text-danger">{t("Rejected")} ({getKycInfo?.kyc_photo_proof1_reason})</p>
                                                                                    :
                                                                                    getKycInfo?.kyc_photo_proof1_status === 0 ?
                                                                                        <p>{t("Pending")}</p>
                                                                                        :
                                                                                        <p>{t("Choose File")}</p>
                                                                        }
                                                                    </div>
                                                                    <div><img src={kycup} alt="" class="img-fluid" />  </div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="kyc-previewbox">
                                                            {kycFrontPreview || kycFront ? <img src={kycFrontPreview ? kycFrontPreview : kycFront ? kycFront : ""} class="kycPreview"></img> : null}
                                                            <p style={{ color: getKycInfo?.kyc_photo_proof1_status === 1 ? "greenyellow" : getKycInfo?.kyc_photo_proof1_status === 2 ? "red" : "" }}>
                                                                {getKycInfo?.kyc_photo_proof1_status === null ? `${t("Preview")}` : getKycInfo?.kyc_photo_proof1_status === 0 ? `${t("Pending")}` : getKycInfo?.kyc_photo_proof1_status === 1 ? `${t("Approved")}` : getKycInfo?.kyc_photo_proof1_status === 2 ? `${t("Rejected")}` : `${t("Preview")}`}
                                                            </p>
                                                        </div>
                                                        {errors.kycfrontimage && (
                                                            <span class="text-danger">{errors.kycfrontimage.message}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 mt-4 mt-sm-0">
                                                    <div class="form-group">
                                                        <label for="">{t("Back Side ID Proof")}</label>
                                                        <div class="kyc-upload">
                                                            <input type="file" disabled={getKycInfo?.kyc_photo_proof2_status === 1 || getKycInfo?.kyc_photo_proof2_status === 0 ? true : false} id="back-id" name="kycbackimage"
                                                                onChange={(e) => handleChange(e, "back")}
                                                            />
                                                            <label for="back-id" style={{ cursor: getKycInfo?.kyc_photo_proof2_status === 1 || getKycInfo?.kyc_photo_proof2_status === 0 ? "not-allowed" : "pointer" }}>
                                                                <div class="choosefile-grid">
                                                                    <div>
                                                                        {
                                                                            getKycInfo?.kyc_photo_proof2_status === 1 ?
                                                                                <p>{t("Approved")}</p>
                                                                                :
                                                                                getKycInfo?.kyc_photo_proof2_status === 2 ?
                                                                                    <p class="text-danger">{t("Rejected")}   ({getKycInfo?.kyc_photo_proof2_reason})</p>
                                                                                    :
                                                                                    getKycInfo?.kyc_photo_proof2_status === 0 ?
                                                                                        <p>{t("Pending")}</p>
                                                                                        :
                                                                                        <p>{t("Choose File")}</p>
                                                                        }
                                                                    </div>
                                                                    <div><img src={kycup} alt="" class="img-fluid" />  </div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="kyc-previewbox">
                                                            {kycBackPreview || kycBack ? <img src={kycBackPreview ? kycBackPreview : kycBack ? kycBack : ""} class="kycPreview"></img> : null}
                                                            <p style={{ color: getKycInfo?.kyc_photo_proof2_status === 1 ? "greenyellow" : getKycInfo?.kyc_photo_proof2_status === 2 ? "red" : "" }}>
                                                                {getKycInfo?.kyc_photo_proof2_status === null ? `${t("Preview")}` : getKycInfo?.kyc_photo_proof2_status === 0 ? `${t("Pending")}` : getKycInfo?.kyc_photo_proof2_status === 1 ? `${t("Approved")}` : getKycInfo?.kyc_photo_proof2_status === 2 ? `${t("Rejected")}` : `${t("Preview")}`}
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <p class="img-format">{t("ID or Driver’s license Front ( jpg, png,jpeg)")}</p>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="kyc-selfie">
                                                        <input type="file" disabled={getKycInfo?.kyc_photo_self_status === 1 || getKycInfo?.kyc_photo_self_status === 0 ? true : false} name="kycselfieimage" id="kyc-selfie" onChange={(e) => handleChange(e, "selfie")} />
                                                        <label for="kyc-selfie" style={{ cursor: getKycInfo?.kyc_photo_self_status === 1 || getKycInfo?.kyc_photo_self_status === 0 ? "not-allowed" : "pointer" }}>
                                                            <div class="kycselfie-grid">
                                                                <div>
                                                                    <img src={kycSelfiePreview ? kycSelfiePreview : kycSelfie ? kycSelfie : camera} alt="" class="img-fluid" />
                                                                </div>
                                                                <div class="ml-3">
                                                                    <h5>{t("KYC Selfie ID Proof")}</h5>
                                                                    <p>{t("selfie content")}</p><br />
                                                                    {
                                                                        getKycInfo?.kyc_photo_self_status === 1 ?
                                                                            <p style={{ color: getKycInfo?.kyc_photo_self_status === 1 ? "greenyellow" : getKycInfo?.kyc_photo_self_status === 2 ? "red" : "" }}>{t("Approved")}</p>
                                                                            :
                                                                            getKycInfo?.kyc_photo_self_status === 2 ?
                                                                                <p class="text-danger">{t("Rejected")}  ({getKycInfo?.kyc_photo_self_reason})</p>
                                                                                :
                                                                                getKycInfo?.kyc_photo_self_status === 0 ?
                                                                                    <p>{t("Pending")}</p>
                                                                                    :
                                                                                    <p>{t("Not Upload")}</p>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="kycsubmit-btn">
                                                <button class="btn btn-primary" disabled={getKycInfo?.kyc_photo_proof1_status === 1 && getKycInfo?.kyc_photo_proof2_status === 1 && getKycInfo?.kyc_photo_self_status === 1 ? true : getKycInfo?.kyc_photo_proof1_status === 0 || getKycInfo?.kyc_photo_proof2_status === 0 || getKycInfo?.kyc_photo_self_status === 0 ? true : false} type="submit" onClick={(e) => updateKyc(e)}>{t("Submit")}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </Fragment >
    );

}

export default Kyc;